export default "__VITE_ASSET__DCw8948a__"